import { combineEpics } from "redux-observable"
import {
    createEpic,
    createFromReferenceEpic,
    deleteEpic,
    fetchEpic,
    inventoryAdjustmentEpic,
    markAsDoneEpic,
    quickCreateStockDocumentEpic,
    reloadEpic,
    unarchiveEpic
} from "./epics"

export const StockDocumentEpics = combineEpics(
    fetchEpic,
    createEpic,
    deleteEpic,
    unarchiveEpic,
    markAsDoneEpic,
    createFromReferenceEpic,
    inventoryAdjustmentEpic,
    reloadEpic,
    quickCreateStockDocumentEpic,
)



// WEBPACK FOOTER //
// ./src/state/inventory/stockdocument/epics/index.ts